import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/accountConfigService";
const store = {};
const mutations = {
    GET_ACCOUNT_CONFIGURATION(state, posts) {
        state.accountConfigList = posts.accountConfig;
        state.accountConfigListChanged = false;
        state.accountConfigListIsLoading = false;
    },
    SAVE_ACCOUNT_CONFIGURATION(state, posts) {
        if (posts.success == true) {
            state.accountConfigListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    accountConfigListIsLoading: false,
    accountConfigListChanged: false,
    accountConfigList: [],
};
const getters = {};
const actions = {
    getAccountConfiguration({ commit }, data) {
        state.accountConfigListIsLoading = true;
        axios
            .get(baseUri + '/GetAccountConfiguration?grpId=' + data.grpId + "&manId=" + data.manId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ACCOUNT_CONFIGURATION', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveAccountConfiguration({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.accountConfigList));
        axios
            .post(baseUri + '/SaveAccountConfiguration', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_ACCOUNT_CONFIGURATION', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}